import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
// 翻訳リソース
import ja from './locales/ja/translation.json';

export const resources = {
  ja: {
    translation: ja,
  },
  en: {
    translation: en,
  },
} as const;

/**
 * 多言語化機能の初期化
 * 多言語化は常に有効
 */
function initializeI18n(): void {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'ja', // デフォルト言語を日本語に設定
      debug: false, // デバッグメッセージを無効化

      interpolation: {
        escapeValue: false, // React already does escaping
      },

      detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
      },

      // 最新版での推奨設定
      react: {
        useSuspense: false, // React 18での推奨設定
      },

      // パフォーマンス最適化
      load: 'languageOnly',
      preload: ['ja', 'en'],
    });
}

// i18nを初期化
initializeI18n();

export default i18n;
